import { Decimal } from 'decimal.js'

/**
 * Alternatives
 */
const DietarySemiProductAlternativeDetailsToModel = (
	data: IDietarySemiProductAlternativeDetails,
): IDietarySemiProductAlternativeDetailsModel => {
	const { id, name_trans, internal_name, warehouse_name } = data

	return {
		id,
		name: name_trans,
		internalName: internal_name,
		warehouseName: warehouse_name,
	}
}

export const DietarySemiProductAlternativeToModel = (
	data: IDietarySemiProductAlternative,
): IDietarySemiProductAlternativeModel => {
	const {
		id,
		order,
		net_weight,
		group_id,
		original_raw_material_id,
		alternative_raw_material_id,
		alternative_raw_material,
	} = data

	return {
		id,
		order: order ?? null,
		netWeight: net_weight,
		groupId: group_id ?? null,
		originalRawMaterialId: original_raw_material_id,
		alternativeRawMaterialId: alternative_raw_material_id,
		alternativeRawMaterial: alternative_raw_material
			? DietarySemiProductAlternativeDetailsToModel(alternative_raw_material)
			: null,
	}
}

export const DietarySemiProductAlternativeModelToManage = (
	model: IDietarySemiProductAlternativeModel,
	standardizationFactor: number,
): IDietaryAlternativeMaterialManage => {
	const { id, order, netWeight, groupId, originalRawMaterialId, alternativeRawMaterialId, alternativeRawMaterial } =
		model

	return {
		id,
		groupId,
		netWeight: Number(new Decimal(netWeight).times(standardizationFactor).toFixed(2)),
		type: EDietSharedComponentType.MATERIAL,
		name: alternativeRawMaterial?.name ?? 'Nieznany',
		internalName: alternativeRawMaterial?.internalName ?? 'Nieznany',
		order: order ?? undefined,
		alternativeMaterialId: alternativeRawMaterialId,
		originalMaterialId: originalRawMaterialId,
	}
}
